import React from 'react';
import { observer } from 'mobx-react-lite';
import { FrameContexts, IAppManifest } from '@metaos/hub-sdk';
import type { PromiseHandlers, DialogActions } from 'owa-app-host-services';
import { DialogService } from 'owa-app-host-services';
import MetaOsAppHostContainerWrapper from '../metaOsAppHost/MetaOsAppHostContainerWrapper';

export interface ITaskModuleContentUrl {
    contentUrl: string;
    actions: DialogActions;
    appDefinition: IAppManifest;
    promiseHandlers: PromiseHandlers;
}

export default observer(function TaskModuleContentUrl(props: ITaskModuleContentUrl) {
    const { appDefinition, actions, promiseHandlers, contentUrl } = props;

    return (
        <MetaOsAppHostContainerWrapper
            appDefinition={appDefinition}
            contentUrl={contentUrl}
            context={{
                page: { frameContext: FrameContexts.task },
            }}
            hubServices={{
                dialogService: new DialogService(actions, promiseHandlers),
            }}
        />
    );
});
